<template>
  <div>
    <b-card bg-variant="light">
      <b-card-header>
        <div class="header-content">
          <div>
            <span>
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
              <strong class="padding-left-5">Drug reference</strong>
              Manage PAP Details
            </span>
            <span v-if="!isAddRefrenceDrug" style="font-size:0.6rem">&nbsp;>&nbsp;DRUG SUMMARY</span>
          </div>
          <div v-if="!isAddRefrenceDrug" class="header-content-right-wrapper">
            <div>
              <span class="logo-text">
                <strong>{{selectedBrandNameRecord.brand}}</strong>
              </span>
            </div>
            <div>
              <span class="header-item">
                <strong>ImpaxRx PAP: {{selectedBrandNameRecord.isPAPI}}</strong>
              </span>
              <span class="header-item">
                <strong>Date Ended: {{selectedBrandNameRecord.edate}}</strong>
              </span>
            </div>
            <div>
              <span class="header-item retail-text">Retail PAP: {{selectedBrandNameRecord.isPAPR}}</span>
              <span
                class="header-item retail-text"
              >Retail Fee: {{selectedBrandNameRecord.retailFee}}</span>
            </div>
          </div>
        </div>
      </b-card-header>
      <b-card-body>
        <b-card>
          <div style="display:grid;grid-gap : 2rem">
            <div style="display:grid;grid-template-columns: repeat(4, 1fr);grid-gap:0.8rem">
              <b-form-group label="Brand Name">
                <b-form-input v-model="selectedDugDetailCopy.brand"></b-form-input>
              </b-form-group>
              <b-form-group label="Generic">
                <b-form-input v-model="selectedDugDetailCopy.generic"></b-form-input>
              </b-form-group>
            </div>
            <div style="display:grid;grid-template-columns: repeat(1, 1fr);padding-right: .4rem;">
              <b-form-group label="PAP Comments">
                <b-form-input
                  v-model="selectedDugDetailCopy.comment"
                  placeholder="Enter any current comments here"
                ></b-form-input>
              </b-form-group>
            </div>
            <div style="display:grid;grid-template-columns:22% 11% 11% 18% 20% 11%;grid-gap:0.8rem">
              <div>
                <strong>ImpaxRx PAP Drug?</strong>
                <b-form-checkbox
                  class="drug-switch"
                  v-model="selectedDugDetailCopy.iRxEligible"
                  name="check-button"
                  switch
                />
              </div>
              <div>
                <b-form-group label="Start Date">
                  <b-form-datepicker
                    id="startDate-datepicker"
                    placeholder="Start Date"
                    size="sm"
                    v-model="selectedDugDetailCopy.startDate"
                    today-button
                    reset-button
                    close-button
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    :state="isValidStartDate"
                  />
                </b-form-group>
              </div>
              <div>
                <b-form-group label="End Date">
                  <b-form-datepicker
                    id="endDate-datepicker"
                    placeholder="End Date"
                    size="sm"
                    v-model="selectedDugDetailCopy.endDate"
                    today-button
                    reset-button
                    close-button
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    :state="isValidEndDate"
                  />
                </b-form-group>
              </div>
              <div>
                <strong>Short Duration?</strong>
                <b-form-checkbox
                  class="drug-switch"
                  v-model="selectedDugDetailCopy.shortDuration"
                  name="check-button"
                  switch
                />
              </div>
              <div>
                <strong>Retail PAP Drug?</strong>
                <b-form-checkbox
                  class="drug-switch"
                  v-model="selectedDugDetailCopy.retailEligible"
                  name="check-button"
                  switch
                />
              </div>
              <div>
                <b-form-group label="Retail Fee">
                  <b-form-input
                    v-model="selectedDugDetailCopy.retailFee"
                    :state="$v.selectedDugDetailCopy.retailFee.$error 
                    ? $v.selectedDugDetailCopy.retailFee.isValidRetailFee 
                    : null
                    "
                  />
                </b-form-group>
              </div>
            </div>
            <div style="display:grid;grid-template-columns: repeat(4, 1fr);grid-gap:0.5rem ">
              <div style="grid-column:5/5">
                <b-button @click="cancelBrandRecord" class="btn-cancel">Cancel</b-button>
                <b-button @click="saveUpdateBrandRecord" class="btn-save">
                  <span v-if="isAddRefrenceDrug">Save Record</span>
                  <span v-if="!isAddRefrenceDrug">Update Record</span>
                </b-button>
              </div>
            </div>
          </div>
        </b-card>

        <b-tabs v-if="!isAddRefrenceDrug">
          <b-tab active>
            <template v-slot:title>
              <strong class="tabs">Known NDCs</strong>
            </template>
            <KnownNDCs class="t-c" :brand-id="brandId" />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <strong class="tabs">Programs</strong>
            </template>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <strong class="tabs">Drug Metrics</strong>
            </template>
            <p class="t-c">Tab Contents 2</p>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </div>
</template>



<script>
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import { router } from '@/router';
import KnownNDCs from './Tabs/KnownNDCs/Index';
import { validateTwoDates } from '@/shared/utils';

export default {
  name: 'DrugDetails',
  props: ['recordId'],
  components: {
    KnownNDCs
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('brandName', [
      'selectedBrandNameRecord',
      'paging',
      'selectedDugDetailCopy'
    ]),
    isValidStartDate() {
      const { startDate, endDate } = this.selectedDugDetailCopy;
      if (_.isEmpty(startDate) && !_.isEmpty(endDate)) {
        return false;
      }
      return null;
    },
    isValidEndDate() {
      const { startDate, endDate } = this.selectedDugDetailCopy;

      if (_.isEmpty(startDate) && !_.isEmpty(endDate)) {
        this.isValidStartDate;
        return null;
      } else if (!_.isEmpty(startDate) && !_.isEmpty(endDate)) {
        const isValidDates = validateTwoDates(startDate, endDate);
        return isValidDates ? null : false;
      } else return null;
    },
    brandId() {
      const drugBrandId = this.$route.params.id;
      return _.isEmpty(drugBrandId) ? '' : drugBrandId;
    },
    isAddRefrenceDrug() {
      return _.isEmpty(this.brandId);
    }
  },
  validations() {
    return {
      selectedDugDetailCopy: {
        retailFee: {
          isValidRetailFee(val) {
            return _.isEmpty(val) ? true : /^\d{1,10}(\.\d{1,4})?$/.test(val);
          }
        }
      }
    };
  },
  methods: {
    ...mapActions('brandName', [
      'getBrandDetailById',
      'saveDrugBrandDetail',
      'updateDrugBrandDetail'
    ]),

    async saveUpdateBrandRecord() {
      this.$v.$touch();

      if (
        this.$v.$invalid ||
        this.isValidEndDate === false ||
        this.isValidStartDate === false
      ) {
        return;
      }

      if (this.isAddRefrenceDrug) {
        await this.saveDrugBrandDetail(this.selectedDugDetailCopy);
        //REDIRECT USER TO DRUG DETAIL GRID
        router.push('/drugDatabase/brandname');
      } else {
        await this.updateDrugBrandDetail(this.selectedDugDetailCopy);
      }
    },
    cancelBrandRecord() {
      router.push('/drugDatabase/brandname');
    }
  },

  async created() {},
  async mounted() {
    await this.getBrandDetailById(this.brandId);
  }
};
</script>
<style  scoped>
.tabs {
  color: red;
}
.t-c {
  color: black;
}
.header-content {
  display: grid;
  grid-template-columns: 40% 60%;
}
.header-item {
  padding: 0 0.35vw;
}
.logo-text {
  color: darkred;
  /* padding-right: 2vw; */
}
.retail-text {
  font-size: 0.7rem;
}
.header-content-right-wrapper {
  display: grid;
  grid-template-columns: 18% 56% 30%;
}

.padding-left-5 {
  padding-left: 5px;
}
.drug-switch {
  display: initial;
  top: -0.2rem;
  padding-left: 3.6rem;
}
</style>